module.exports = __webpack_public_path__ + "img/94ne.296436f6.svg";